import tw from 'twin.macro';
import { jsx } from '@emotion/react';

const PageWrapper = tw.div`flex flex-1 flex-col`;
export default PageWrapper;
